import React, { forwardRef, InputHTMLAttributes, ReactNode } from 'react';
import cn from 'classnames';

export interface RadioButtonProps
    extends InputHTMLAttributes<HTMLInputElement> {
    id: string;
    /** Label inside the radio button, can also contain React elements */
    label?: ReactNode;
    children?: ReactNode;
}

/**
 * @name    a-radioButton
 * @type    atom
 *
 * @param   {string} id           ID of the Input Field
 * @param   {string} label        Label to show next to Radio-Button
 * @param   {string} value        Value of Radio-Button
 * @param   {string} name         Optional Name of Input-Group
 * @param   {boolean} disabled    Disable input field
 * @param   {boolean} checked     Check input field
 * @description
 * representation of radio buttons
 */
export const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
    (props, ref) => {
        const { id, label, className, style, children, ...rest } = props;
        const classes = cn('a-radio-button', className);
        const idRadio = `radio-button-${id}`;
        return (
            <div className={classes} style={style}>
                <input id={idRadio} type="radio" ref={ref} {...rest} />
                <label htmlFor={idRadio}>{label ? label : children}</label>
            </div>
        );
    },
);

RadioButton.displayName = 'RadioButton';
